import React from 'react';
import { BuildingIcon, SearchIcon, UsersIcon, CpuIcon, CheckCircleIcon } from 'lucide-react';
export function ScraperPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-1570">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1571">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1572">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1573">
            Pricing for every{' '}
            <span className="text-blue-600" data-id="element-1574">Google Maps data</span> workflow
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-1575">
            Pay only for the local business data you extract. Every account
            starts with free credits to test our Google Maps scraper.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-1576">
          {/* Search Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1577">
            <div className="flex items-center gap-3 mb-4" data-id="element-1578">
              <SearchIcon className="w-5 h-5 text-slate-400" data-id="element-1579" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1580">
                Search Google Maps data
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1581">
              Find businesses by location, category, and rating from Google Maps
              data
            </p>
            <div data-id="element-1582">
              <div className="flex items-baseline gap-2" data-id="element-1583">
                <span className="text-4xl font-bold text-slate-900" data-id="element-1584">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1585">unlimited searches</p>
            </div>
          </div>

          {/* Find People Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1586">
            <div className="flex items-center gap-3 mb-4" data-id="element-1587">
              <UsersIcon className="w-5 h-5 text-slate-400" data-id="element-1588" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1589">
                Find decision makers
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1590">
              Get verified owner contacts for businesses scraped from Google
              Maps
            </p>
            <div className="space-y-4" data-id="element-1591">
              <div data-id="element-1592">
                <div className="flex items-baseline gap-2" data-id="element-1593">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-1594">
                    from $3
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-1595">
                  per 100 contacts found
                </p>
              </div>
              <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-100" data-id="element-1596">
                <div data-id="element-1597">
                  <div className="text-lg font-bold text-slate-900" data-id="element-1598">$3</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-1599">per 100 names</p>
                </div>
                <div data-id="element-1600">
                  <div className="text-lg font-bold text-slate-900" data-id="element-1601">$6</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-1602">per 100 emails</p>
                </div>
                <div data-id="element-1603">
                  <div className="text-lg font-bold text-slate-900" data-id="element-1604">$24</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-1605">per 100 phones</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tech Stack Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1606">
            <div className="flex items-center gap-3 mb-4" data-id="element-1607">
              <CpuIcon className="w-5 h-5 text-slate-400" data-id="element-1608" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1609">
                Detect tech stack
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1610">
              Identify what tools Google Maps businesses use to personalize your
              outreach
            </p>
            <div data-id="element-1611">
              <div className="flex items-baseline gap-2" data-id="element-1612">
                <span className="text-4xl font-bold text-slate-900" data-id="element-1613">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1614">
                per 100 records enriched
              </p>
            </div>
          </div>

          {/* Export Leads Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-1615">
            <div className="flex items-center gap-3 mb-4" data-id="element-1616">
              <BuildingIcon className="w-5 h-5 text-slate-400" data-id="element-1617" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1618">Export leads</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-1619">
              Export enriched leads with employee count, hiring signals, and
              more
            </p>
            <div data-id="element-1620">
              <div className="flex items-baseline gap-2" data-id="element-1621">
                <span className="text-4xl font-bold text-slate-900" data-id="element-1622">$0.15</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1623">
                per 100 records exported
              </p>
            </div>
          </div>
        </div>

        {/* Trust Signals */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-1624">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-1625">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-1626" />
            <span data-id="element-1627">Pay only for results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-1628">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-1629" />
            <span data-id="element-1630">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-1631">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-1632" />
            <span data-id="element-1633">No credit card required</span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-1634">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-1635">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-1636">
              Try for free
            </a>
          </div>
          <p className="text-sm text-slate-500 font-medium" data-id="element-1637">
            No credit card required
          </p>
        </div>
      </div>
    </section>;
}